export default {
    methods: {
        getTitle: function (title, maxLength=50) {
            if (title.length <= maxLength) {
                return title;
            }
            return title.slice(0, maxLength) + '...';
        },

        removeCenter: function (title) {
            title = title.replace('<center>', "<div>");
            title = title.replace('</center>', "</div>");

            return title;
        },
        getBody: function (title, maxLength=50) {
            title = this.convertHTMLToText(title);
            if (title.length <= maxLength) {
                return title;
            }
            return title.slice(0, maxLength) + '...';
        },
        convertHTMLToText: function (html) {
            // Create a temporary DOM element to strip tags
            let div = document.createElement('div');
            div.innerHTML = html;
            return div.textContent || div.innerText || '';
        },
        getUrlParam(paramName) {
            var reParam = new RegExp('(?:[?&]|&)' + paramName + '=([^&]+)', 'i');
            var match = window.location.search.match(reParam);
            return (match && match.length > 1) ? match[1] : null;
        }

    }
}
